import { render, staticRenderFns } from "./userProfile.vue?vue&type=template&id=0731ea14"
import script from "./userProfile.vue?vue&type=script&lang=js"
export * from "./userProfile.vue?vue&type=script&lang=js"
import style0 from "./userProfile.vue?vue&type=style&index=0&id=0731ea14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports